// extracted by mini-css-extract-plugin
export default {"cancel-button":"TrackNotifyRecipient_cancel-button__SZrV7","okay-button":"TrackNotifyRecipient_okay-button__kbRT3"};